import { Url } from '@wix/da-url';
import { PapiComment } from '@wix/da-papi-types';
import { CommentableTypes } from '../Comment/redux/types';

export const getModuleCommentableUrl = (moduleData, comment?: PapiComment) => {
  if (comment && comment.typeId && comment.itemId) {
    switch (comment.typeId) {
      case CommentableTypes.COMMENT_BPP_MSG_MODULE_PUBLIC:
        return Url.groupLogLink(moduleData.group.username, `${comment.itemId}`);
      case CommentableTypes.COMMENT_BPP_MSG_MODULE:
        return moduleData.correspondenceUrl || undefined;

      default:
        return undefined;
    }
  }
};
